/* eslint-disable */
import { isIOS } from "@tmsw/powerups.utils.is-ios";

let descReadTimeout;

export let AudioDescriptionEvent = new CustomEvent("audioDescriptionEvent", {
  detail: {
    status: null,
    description: null,
    cue: null,
    pauseVideo: false,
  },
});

class AudioDescriptionsClass {
  static STATUSES = {
    INITIALIZING: "initializing",
    PAUSED: "paused",
    PENDING: "pending",
    SPEAKING: "speaking",
  };

  isUsingSpeechAPI:boolean;

  locale: string;

  lastDesc: string | null;

  speechRate: number;

  speechMethod: SpeechSynthesis;

  speechMethodFallback: HTMLDivElement;

  voice: SpeechSynthesisVoice;

  // Private Props
  #paused = true;

  #pending = false;

  #speaking = false;

  constructor(rate = 120) {
    this.isUsingSpeechAPI = SpeechSynthesisUtterance !== undefined;
    this.locale = new URLSearchParams(window.location.search).get("locale") || "en-US";
    this.lastDesc = null;
    this.speechRate = rate || 120;

    if (this.isUsingSpeechAPI) {
      this.speechMethod = window.speechSynthesis;

      if (isIOS()) {
        const voices = this.speechMethod.getVoices();
        this.voice = voices.find((voice) => voice.lang === this.locale);
      } else {
        this.speechMethod.addEventListener("voiceschanged", () => {
          const voices = this.speechMethod.getVoices();
          this.voice = voices.find((voice) => voice.lang === this.locale);
        });
      }
    } else {
      this.speechMethodFallback = document.createElement("div");
      this.speechMethodFallback.setAttribute("aria-live", "assertive");
      this.speechMethodFallback.style.position = "absolute";
      this.speechMethodFallback.style.opacity = '0';
      this.speechMethodFallback.style.pointerEvents = "none";
      document.body.appendChild(this.speechMethodFallback);
    }
    AudioDescriptionEvent.detail.status = AudioDescriptionsClass.STATUSES.INITIALIZING;
    dispatchEvent(AudioDescriptionEvent);
  }

  get paused() {
    let status;
    if (this.isUsingSpeechAPI) {
      status = this.#paused = this.speechMethod.paused;
    }
    return status;
  }

  get speaking() {
    let status;
    if (this.isUsingSpeechAPI) {
      status = this.#speaking = this.speechMethod.speaking;
    }
    return status;
  }

  get pending() {
    let status;
    if (this.isUsingSpeechAPI) {
      status = this.#pending = this.speechMethod.pending;
    }
    return status;
  }

  speak(text, shouldDispatchEvents = true) {
    if (this.isUsingSpeechAPI) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.addEventListener("start", (evt) => {
        AudioDescriptionEvent.detail.status = AudioDescriptionsClass.STATUSES.SPEAKING;
        if (shouldDispatchEvents) dispatchEvent(AudioDescriptionEvent);
      });
      utterance.addEventListener("end", (evt) => {
        AudioDescriptionEvent.detail.status = AudioDescriptionsClass.STATUSES.PAUSED;
        AudioDescriptionEvent.detail.pauseVideo = false;
        if (shouldDispatchEvents) dispatchEvent(AudioDescriptionEvent);
        clearTimeout(descReadTimeout);
        console.trace(evt.target);
        // @ts-ignore
        delete evt.target;
      });
      utterance.voice = this.voice;
      this.speechMethod.speak(utterance);
    } else {
      AudioDescriptionEvent.detail.status = AudioDescriptionsClass.STATUSES.SPEAKING;
      if (shouldDispatchEvents) dispatchEvent(AudioDescriptionEvent);
      this.speechMethodFallback.innerHTML = text;
    }

    console.log(`Audio Description: ${text}`);
  }

  readDescription(description) {
    if (description instanceof VTTCue) {
      if (description.text.length && description.text !== this.lastDesc) {
        this.lastDesc = description.text;  // to avoid repeated description from being read
        const wordCounter = description.text.split(" ");
        const descDuration = wordCounter.length * (60 / this.speechRate);
        const shouldPauseVideo = descDuration >= description.endTime - description.startTime;

        AudioDescriptionEvent.detail.pauseVideo = shouldPauseVideo;

        if (shouldPauseVideo) {
          AudioDescriptionEvent.detail.pauseVideo = true;

          descReadTimeout = setTimeout(() => {
            console.log("timeout: reading pause ended");
            clearTimeout(descReadTimeout);
            AudioDescriptionEvent.detail.status = AudioDescriptionsClass.STATUSES.PAUSED;
            AudioDescriptionEvent.detail.pauseVideo = false;
            dispatchEvent(AudioDescriptionEvent);
          }, descDuration * 1000);
        }

        this.speak(description.text);
      }
    } else if (typeof description === "string") {
      this.speak(description);
    }
  }

  cancel() {
    if (this.isUsingSpeechAPI) {
      this.speechMethod.cancel();
      clearTimeout(descReadTimeout);
    } else {
      this.speechMethodFallback.innerHTML = "";
      clearTimeout(descReadTimeout);
    }
  }
}

export const AudioDescriptions = new AudioDescriptionsClass();
